export default __webpack_public_path__ + "images/pdf_16.png";